// ReCAPTCHA
import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RecaptchWrapper = forwardRef((recaptchProps, ref) => <ReCAPTCHA {...recaptchProps} ref={ref} />);

export default RecaptchWrapper;
